export default class PlzInput {
  constructor(element, position) {
    this.element = element;
    this.position = position;
    this.observers = [];
    this.initEventListeners();
  }
  initEventListeners() {
    this.element.addEventListener("keydown", this.handleKeydownEvent.bind(this));
  }
  focus() {
    this.element.focus();
  }
  handleKeydownEvent(event) {
    if (event.key === "Backspace") {
      event.preventDefault();
      if (!this.element.value) {
        this.emit("back");
      } else {
        this.setValue("");
        this.emit("clear");
      }
    }
    if (isFinite(event.key) && event.key !== " ") {
      event.preventDefault();
      this.setValue(event.key);
      this.emit("change");
    }
    if (event.key == "ArrowRight") {
      this.emit("next");
    }
    if (event.key == "ArrowLeft") {
      this.emit("prev");
    }
  }
  isEmpty() {
    return this.element.value === "";
  }
  getValue() {
    return this.element.value;
  }
  setValue(value, informObservers = false) {
    this.element.value = value;
    if (informObservers)
      this.emit("change");
  }
  clear(informObservers = false) {
    this.setValue("", informObservers);
  }
  emit(eventName) {
    this.observers.forEach((observer) => {
      observer.notify(eventName, this);
    });
  }
  addObserver(inputObserver) {
    this.observers.push(inputObserver);
  }
}
